  import React, { useEffect, useState, useRef } from 'react';

  import { Swiper, SwiperSlide } from 'swiper/react';
  import { Navigation, Autoplay } from 'swiper/modules';
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  import { faSearch } from '@fortawesome/free-solid-svg-icons';
  import { EffectCreative } from 'swiper/modules';
  import { Link } from 'react-router-dom';
  import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
  import './Main.css';
  import { Pagination } from 'swiper/modules';
  import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
  import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
  import axios from "axios";
  import { NavLink } from "react-router-dom";
  import CONFIG from "./config";

  const Header = () => {
    
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('Empower');
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [expandedBox, setExpandedBox] = useState(null);
  const [current, setCurrent] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const toggleBox1 = () => {
    setExpandedBox(expandedBox === "box1" ? null : "box1");
  };
    
const [expandedBox3, setExpandedBox3] = useState(false);
const [expandedBox4, setExpandedBox4] = useState(false);
const [expandedBox5, setExpandedBox5] = useState(false);
const [expandedBox6, setExpandedBox6] = useState(false);
const [isOpen, setIsOpen] = useState(false);
const [content, setContent] = useState(null);
const closePopup = () => {
  setIsOpen(false);
};
/* api of the popul*/
  useEffect(() => {
    axios
      .get(`${CONFIG.API_BASE_URL}/api/pagecontent/1`) // ✅ Correct string interpolation
      .then((res) => {
        console.log("API Response:", res.data);

        const pageDesc = res.data?.data?.page_description || "";
        setContent(pageDesc);

        // Open popup only after content is fetched
        setIsOpen(true);
      })
      .catch((err) => {
        console.error("Error fetching content:", err);
      });
  }, []);

  useEffect(() => {
    if (
      swiperRef.current &&
      prevRef.current &&
      nextRef.current &&
      swiperRef.current.params
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      // Re-init navigation
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + length) % length);
  };
  
  const navItems = [
    { title: 'आम्ही कोण आहोत?', path: '/leadership' },
    { title: 'बातम्या आणि ब्लॉग', path: '/news' },
    { title: 'संपर्क करा', path: '/contact' },
  ];
  const images = [
    'banner6.png',
    'banner6.png',
    
  ];
  const length = images.length;
  const tabs = [
  {
    title: "",
    heading: "",
    text: `महाराष्ट्र लोकाधिकार समितीच्या कार्याचा प्रसार, सामाजिक भान वाढविणे, विविध विषयांवरील योग्य माहिती पोहोचविणे, समुदायाला सक्षम, साजरे आणि शिक्षित करण्यास मदत करणे. या उद्देशाने आम्ही आमच्या संघटनेच्या वेबसाइट/सोशल मीडियावर आर्टिकल्स आणि ब्लॉक्स प्रकाशित करण्याचा उपक्रम सुरू केला आहे.
  यासाठी आपल्या सर्वाना आवाहन आहे की –
  आपल्या अनुभवावर आधारित लेख, प्रेरणादायी कथा, सामाजिक समस्या, उपाययोजना, उद्योग/व्यवसाय विषयक मार्गदर्शन, शेती, शिक्षण, आरोग्य, संस्कृती, इतिहास इ. विषयांवरील माहितीपूर्ण आर्टिकल किंवा ब्लॉक तयार करून आम्हाला पाठवावेत...`,
    link: "",
    image: "sideimgnew.png",
  },

  
  ];

    const announcements = [
    {
      img: 'https://pir.org/wp-content/uploads/2024/08/53282157777_959acd60b1_o-scaled.jpg',
      title: 'Call for Nominations: Seventh Annual .ORG Impact Awards to Recognize Global Changemakers',
      desc: 'Nominations are now OPEN for the seventh annual .ORG Impact Awards. Learn how you can contribute today.',
      link: 'https://pir.org/news-insights/call-for-nominations-seventh-annual-org-impact-awards-to-recognize-global-changemakers/'
    },
    {
      img: 'https://pir.org/wp-content/uploads/2024/10/OOTYPressCard.jpg',
      title: 'Public Interest Registry Unveils Winners of 6th Annual .ORG Impact Awards',
      desc: 'During an evening of celebration hosted by Alan Cumming, PIR named Yellow Boat of Hope as the 2024 .ORG of the Year and honored a community of changemakers.',
      link: 'https://pir.org/news-insights/oia-2024-winners/'
    },
    {
      img: 'https://pir.org/wp-content/uploads/2024/06/PIR_IWF-3.png',
      title: 'A Call to Help Disrupt The Spread of Child Sexual Abuse Materials',
      desc: 'Together we can do so much more. Read about PIR’s partnership with the Internet Watch Foundation.',
      link: 'https://pir.org/news-insights/disrupt-the-spread-of-csam/'
    }
  ];

    return (
      
      <>
       {isOpen && (
      <div className="popup-overlay" onClick={closePopup}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
      <button className="popup-close" onClick={closePopup}>
        &times;
      </button>

      <div className="popup-disclaimer">
        <div
          dangerouslySetInnerHTML={{
            __html: content || "<p>Loading disclaimer...</p>",
          }}
        />
      </div>

{/* Simple text button at the bottom */}
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button 
              onClick={closePopup} 
              style={{
                 width: '100%',
                padding: '8px 20px',
                fontSize: '16px',
                background: '#ff6f00',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
    </div>
  </div>
)}

      {/* Header */}
               <header className="header">
                 <div className="nav-container">
                   <div className="logo">
                     <Link to="/">
                       <img src="web.png" alt="PIR Logo" />
                     </Link>
                   </div>
               
                   {/* Desktop Nav */}
                   <nav className="nav-links">
                     {navItems.map((item, index) => (
                       <div key={index} className="nav-item">
                         <Link to={item.path} className="nav-button">
                           {item.title}
                         </Link>
                       </div>
                     ))}
                   </nav>
               
                   {/* Search + Title */}
                   <div className="search-language" style={{ position: "relative" }}>
                     <div
                       style={{
                         position: "absolute",
                         top: "-19px",
                         left: "16px",
                         fontSize: "22px",
                         color: "#FF6F00",
                         fontFamily: "Mukta, sans-serif",
                         whiteSpace: "nowrap",
                         zIndex: 10,
                         pointerEvents: "none",
                       }}
                     >
                       <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                     </div>
               
                     <div className="pir-search-wrapper">{/* Search Bar */}</div>
                   </div>
               
                   {/* Hamburger Toggle */}
                   <button
                     className="mobile-toggle"
                     onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                   >
                     ☰
                   </button>
                 </div>
               
                 {/* Mobile Menu */}
                 {isMobileMenuOpen && (
                   <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                 {navItems.map((item, index) => (
                   <Link
                     key={index}
                     className="mobile-link"
                     to={item.path}
                     onClick={() => setMobileMenuOpen(false)}
                   >
                     {item.title}
                   </Link>
                 ))}
               </div>
                 )}
               </header>
  <div className="slider-container">
    {/* Left Side: Image Slider */}
    <div className="slider-left">
      <div className="slider-overlay-left"></div>
      <div className="slide">
      <img src={images[current]} alt={`Slide ${current}`} className="slider-img" />
      </div>

      {/* Move buttons into a bottom-right nav container */}
      <div className="slider-nav">
        <button className="prev-btn" onClick={prevSlide}>❮</button>
        <button className="next-btn" onClick={nextSlide}>❯</button>
      </div>
    </div>

    {/* Right Side: Your Content */}
    {/* <div className="slider-text-content">
      
      <h1>
        "जनतेचा
  बुलंद आवाज...

      </h1>
      <h1>
        
  जो
  प्रत्येक अन्यायाविरोधात
  मिळवून देईल दाद
  निर्विवाद!"
      </h1>
    </div>
     */}
     {/*  <button class="slider-btn">Explore More</button>*/}
  </div>

        
    <section className="who-we-are">
    <div className="container who-content">
      <div className="who-img">
        <img
          src="web.png"
          alt="PIR Logo"
          width="350"
          height="450"
        />
      </div>
      <div className="who-text">
        <h2>समितीचे ध्येय </h2>
        <h3 className="who-text-english">(Mission Statement of Maharashtra Lokadhikar Samiti)</h3>
        <p> <h4 className='headingh4'> "भारतीय राज्य घटनेला अभिप्रेत लोकाधिकारांसाठी – करूया संघर्ष न्याय्य हक्कांसाठी"</h4></p>
        <p>
          <b>महाराष्ट्र लोकाधिकार समिती </b>ही २००५ सालापासून न्याय, अधिकार आणि स्वाभिमान यांसाठी सातत्याने झगडणारी एक जिवंत आणि संघर्षशील
          सामाजिक चळवळ आहे. आमचे मुख्य ध्येय म्हणजे — महाराष्ट्रातील कर्जबाजारी शेतकरी, छोटे व्यापारी, मध्यम स्तरातील उद्योजक आणि सर्वसामान्य
          नागरिक यांच्या आर्थिक आणि कायदेशीर हक्कांचे प्रभावी संरक्षण आणि जपणूक करणे.
          आम्ही अशा बँका, पतसंस्था आणि फायनान्स कंपन्यांविरोधात ठाम आवाज उठवतो, ज्या अन्यायकारक, बेकायदेशीर किंवा अमानवी वसुली पद्धतींचा
          अवलंब करतात. <b>संविधानाच्या चौकटीत</b>, <b>कायद्याच्या मार्गाने</b> आणि <b>लोकशाही मूल्यांवर निष्ठा ठेवत</b>, आम्ही प्रत्येक कर्जदाराच्या स्वाभिमानाचे रक्षण
          करण्यासाठी संघटितपणे संघर्ष करत आहोत.
        </p>

        
        <ul className="bullet-list">
          <b>संघटनेचे कार्य तत्त्वे: </b>
          <li>संविधानाने दिलेले मूलभूत हक्क आणि न्यायाची जाणीव समाजातील प्रत्येक स्तरापर्यंत पोहोचवणे</li>
          <li>शासन व व्यवस्थेच्या अन्यायकारक व अयोग्य निर्णयांवर ठाम भूमिका घेऊन लोकहितासाठी संघर्ष करणे</li>
          <li>कायदेशीर साक्षरता वाढवणे, जनजागृतीद्वारे समाजाला सक्षम बनवणे</li>
          <li>गरज भासल्यास, शांततापूर्ण आणि लोकशाही मार्गाने शासनाचे लक्ष वेधून निर्णायक आंदोलन उभारणे</li>
        </ul>
        <br />

        <p>
          <strong>आमची प्रेरणा – संविधान</strong><br />
          डॉ. <b>बाबासाहेब आंबेडकर</b> यांनी दिलेले भारतीय संविधान हेच आमच्या संघटनेचे आधारस्तंभ व प्रेरणास्रोत आहे.
          आमचा ठाम विश्वास आहे:<br />
          <h4 className='headingh4'>"प्रत्येक नागरिकाला जगण्याचा हक्क आहे — सन्मानाने, अस्मितेने आणि अभिमानाने!"</h4>
          हेच आमचे स्वप्न, हेच उद्दिष्ट, आणि हेच अखंड, अटळ व अविचल ध्येय आहे.
        </p>

        <p>
          <strong>आमचा दृष्टिकोन</strong><br />
          आम्ही असा महाराष्ट्र घडवण्याचा संकल्प केला आहे, जिथे प्रत्येक व्यक्तीला आर्थिक, सामाजिक आणि कायदेशीर स्वातंत्र्य लाभेल;
          जिथे कोणीही अन्यायाविरुद्ध आवाज उठवण्यासाठी भीत नाही, आणि
          जिथे न्याय व समानतेच्या मुल्यांशिवाय कोणताही विकास संपूर्ण मानला जाणार नाही.
        </p>

        <p>
         <h4 className='headingh4'>"आमच्या संघर्षात सामील व्हा — स्वाभिमानाने जगण्यासाठी, आणि न्यायासाठी!"</h4>
        </p>
      </div>
    </div>

    <div className="who-buttons">
      <Link to="/leadership" className="blue-btn">
        आम्ही कोण आहोत?
      </Link>
    </div>
  </section>
  <section className="supporting-mission">
    <div className="supporting-wrapper">
      <div className="left-content">
        <div className="top-content">
         <div className="tab-text-content">
            <h3>लोकाधिकार</h3>
            <h4 className='darkheadingh4'>“आपल्या ध्येयाला पाठिंबा द्या..!”</h4>
            {/* <h4>{tabs[activeIndex].heading}</h4> */}
            {/* Preserve line breaks in tab text */}
            <p style={{ whiteSpace: "pre-line" }}>
              {tabs[activeIndex].text}
            </p>
          </div>
          <div className="who-buttons2">
              <Link to="/contact" className="blue-btn2">
              सहभाग नोंदवा / Participate Now
              </Link>
          </div>
        </div>

        <div className="bottom-images">
          <img
            src={tabs[activeIndex].image}
            alt={tabs[activeIndex].title}
            className="tab-image"
          />
        </div>
      </div>

      <div className="right-image">
  <div className="marathi-policy-content">
    <h2>महाराष्ट्र लोकाधिकार समितीचे धोरण</h2>
    <h3>(Policy Statement of Maharashtra Lokadhikar Samiti)</h3>
    <h4 className='headingh4'>“संघर्ष आमचा धर्म, संविधान आमचा मार्ग!” </h4>
    <div style={{ whiteSpace: "pre-line" }}>
      {`महाराष्ट्र लोकाधिकार समिती ही केवळ संघर्ष करणारी संघटना नाही, तर संविधानाच्या मार्गावर अढळ विश्वास ठेवणारी एक लोकशाही संघटना आहे. समाजातील आर्थिक अडचणीत सापडलेल्या नागरिकांच्या न्याय, सन्मान आणि सुरक्षिततेसाठी आम्ही पुढील धोरणात्मक भूमिका घेत आहोत:

➤ बेकायदेशीर वसुलीला कायदेशीर पण ठाम उत्तर
बँका व वित्तीय संस्थांच्या वतीने काम करणारे अनेक रिकव्हरी एजंट धमकी, दहशत आणि मारहाणीच्या मार्गाने कर्जवसुली करत आहेत. ही वागणूक पूर्णतः बेकायदेशीर असून, आम्ही अशा वसुलीचा कायदेशीर चौकटीत राहून ठाम आणि जशास तसे प्रतिकार करू.

➤ सावकारी पद्धतीने वसुली करणाऱ्या एजन्सींचा निषेध
क्रेडिट कार्ड कंपन्यांच्या वतीने काम करणाऱ्या काही एजन्सी सावकारी पद्धतीने वसुली करत असून, त्यामुळे सामान्य कर्जदारांवर मानसिक ताण व दहशतीचे वातावरण निर्माण होते. अशा संस्थांना आम्ही कायदेशीररित्या जाब विचारणार असून, त्यांच्याविरोधात जनजागृती आणि कायदेशीर कारवाईचा निर्णायक लढा उभारणार आहोत.

➤ कर्जदारांना बेघर करणाऱ्या कंपन्यांचा विरोध
फायनान्स कंपन्या आणि NPA एजंट्स दादागिरी, धमकी आणि बेकायदेशीर ताबा मिळवून कर्जदार कुटुंबांना घराबाहेर करण्याचा प्रयत्न करतात. आम्ही अशा अमानुष कारवायांचा तीव्र निषेध करतो आणि कायद्याच्या चौकटीत राहून त्यांचा दृढ विरोध करत राहू.

➤ स्वावलंबी युवा वर्गासाठी ठाम पाठबळ
“आत्मनिर्भर भारत” हे फक्त घोषवाक्य न राहता वास्तव व्हावे, यासाठी आर्थिकदृष्ट्या सक्षम युवा वर्ग घडणे अनिवार्य आहे. व्यवसाय, स्टार्टअप्स किंवा उद्योगांमध्ये अडथळा ठरणाऱ्या अटी, परवाने, कर्जप्रक्रिया यांपासून तरुणांना मुक्त करण्यासाठी संघटना त्यांच्या खांद्याला खांदा लावून साथ देणार आहे.

➤ हक्काची संघटना — सामान्य जनतेसाठी
महाराष्ट्र लोकाधिकार समिती ही सामान्य जनतेच्या हक्कांसाठी लढणारी, संकटात त्यांच्यासोबत उभी राहणारी आणि अन्यायाविरोधात ठाम आवाज उठवणारी खऱ्या अर्थाने लोकांची संघटना आहे. कोणत्याही आर्थिक संकटात, अन्यायाविरोधातील लढ्यात ही संघटना तुमच्यासोबत खंबीरपणे उभी राहील — कारण हा तुमचा हक्काचा आवाज आहे!

`}
<h4 className='headingh4'>“जनतेचा बुलंद आवाज... जो मिळवून देईल प्रत्येक अन्यायाविरोधात दाद! निर्विवाद!!”</h4>
    </div>
  </div>
</div>

    </div>
  </section>

  <div className="global-impact-container">
    {/* Background Circle Image */}
    <div className="global-impact-bg">
      <img
        src="./bg_impact_circles.png"
        alt="Global Impact Circles"
        className="impact-circle-img"
      />
    </div>

    <div className="global-impact-content">
      {/* Top Title */}
      <div className="impact-title">
        <h4 style={{ textAlign: 'center' }}>नेतृत्व</h4>
       <h2 style={{ textAlign: 'center' }}>
  (Leadership of Maharashtra Lokadhikar Samiti)
</h2>

      </div>

      {/* Center Stats Box */}
  <div
  className="global-impact-box">
  <h2 >
    “दिशा फक्त ठरवत नाही, तर परिवर्तनाची मशालही पेटवते!”
  </h2>
  <p>
    <b>महाराष्ट्र लोकाधिकार समितीमध्ये</b> विविध क्षेत्रातील ज्ञान, अनुभव आणि सामाजिक
    बांधिलकी असलेल्या अनेक द्रष्टे, अभ्यासू आणि समर्पित व्यक्ती कार्यरत आहेत. आर्थिक
    धोरणांपासून मानवी हक्कांपर्यंत — समाजाला दिशा देणाऱ्या प्रत्येक महत्त्वाच्या
    मुद्द्यावर त्यांनी ठाम भूमिका घेतली आहे आणि सत्याचा आवाज बनून उभे राहिले आहेत. या
    नेतृत्वकर्त्यांनी केवळ स्वतःचा विकास साधून थांबले नाही, तर आपले ज्ञान, कौशल्य आणि
    अनुभव समाजासाठी खुला ठेवला आहे. संघटनेच्या माध्यमातून त्यांनी एक ज्ञानसंपन्न आणि
    सजग समाज घडवण्याचा वसा घेतला आहे.
  </p>
  <p>
    <b>त्यांचे खरे ध्येय आहे —</b> प्रत्येक कार्यकर्त्याला सक्षम करणे, त्याच्यात जागरूकता
    निर्माण करणे आणि कायद्यानुसार सजग व स्वाभिमानी नागरिक बनवणे.
  </p>
  <p>
    ते केवळ सल्लागार नसून, <b>प्रेरणास्त्रोत</b> आहेत — ज्यांच्या तळमळीने संघटनेला
    दिशा मिळते, जिज्ञासा जागते आणि लढ्याला नवी ऊर्जा प्राप्त होते. त्यांना वाटते की,
    समाजातील शेवटच्या माणसालाही आपले अधिकार समजावेत आणि तो आत्मभान व सन्मानाने
    जगावा.
  </p>
  <p>
    संघटनेशी जोडलेली प्रत्येक व्यक्ती विचारांनी समृद्ध व्हावी, आत्मविश्वासाने आपली
    भूमिका मांडू शकेल, आणि अन्यायाविरुद्ध ठामपणे उभी राहील — हेच या नेतृत्वकर्त्यांचे
    खरे प्रयत्न आहेत. <b>त्यांच्या मार्गदर्शनामुळे</b> संघटनेचे कार्य अधिक व्यापक,
    सुसंगत आणि परिणामकारक बनत आहे — आणि याच नेतृत्वामुळे लोकशक्तीचा आवाज आज अधिक
    ठाम, स्पष्ट आणि प्रभावी झाला आहे.
  </p>
</div>
      {/* Bottom Quote Box */}
      <div className="global-impact-quote dark-blue-text">
        <blockquote>
          {/* <h5>
            "जनतेचा बुलंद आवाज...
            जो प्रत्येक अन्यायाविरुद्ध मिळवून देईल दाद निर्विवाद!"
          </h5> */}
        </blockquote>
      </div>
    </div>
  </div>

  <footer className="pir-footer">
    <div className="footer-container">
      {/* Logo on the left */}
      <div className="footer-left">
        <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
      </div>

      {/* Center: Two columns of links */}
      <div className="footer-center">
        <div className="footer-links-columns">
          <ul className="footer-links">
            <li>
              <a href="/privacypolicy">
                <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
              </a>
            </li>
            <li>
              <a href="/signuppolicy">
                <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
              </a>
            </li>
          </ul>
          <ul className="footer-links">
            <li>
              <a href="/termsuse">
                <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
              </a>
            </li>
            <li>
              <a href="/disclaimer">
                <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social links */}
      <div className="footer-right">
       <div className="footer-social">
                  <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                             <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                             <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                             <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                             <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                 </div>
      </div>
    </div>
    {/* Right side fixed icons */}


    {/* Bottom text */}
    <div className="footer-bottom">
      <p className="marathi-text">
          © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
      </p>
    </div>

  </footer>
  <ul className="right-side-icons">
      <li>
            <a href="/" className="icon-link pulse-glow " title="Home">
              <FontAwesomeIcon icon={faHome} />
            </a>
          </li>
          <li>
            <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
              <FontAwesomeIcon icon={faPhone} />
            </a>
          </li>
        
        </ul>
      </>
    );
  };
  export default Header;